export default __webpack_public_path__ + "6c91790d15a83431c32b8382a777308d.png";